import React from 'react';

import { Box, List, Typography } from '@mui/material';
import { CanAccess, NavigationLink } from 'components';

import { MenuType } from 'types/app';

type Props = {
  menu: MenuType;
  isCollapsed: boolean;
};

export const NavigationMenu: React.FC<Props> = ({ menu, isCollapsed }) => {
  return (
    <Box sx={{ paddingTop: '16px' }}>
      {/* Section title (nav-title) */}
      {!isCollapsed && menu.subHeader && (
        <Typography
          sx={{
            padding: '0 24px',
            marginBottom: '8px',
            fontSize: '11px',
            fontWeight: 700,
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontFamily: 'Montserrat, sans-serif',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {menu.subHeader}
        </Typography>
      )}

      <List disablePadding>
        {menu.items.map((it, index) => (
          <CanAccess key={index} allowedFor={it.userRight}>
            <NavigationLink key={index} item={it} isCollapsed={isCollapsed} />
          </CanAccess>
        ))}
      </List>
    </Box>
  );
};
